import { render, staticRenderFns } from "./SearchCourses.vue?vue&type=template&id=0f265975&scoped=true&"
import script from "./SearchCourses.vue?vue&type=script&lang=js&"
export * from "./SearchCourses.vue?vue&type=script&lang=js&"
import style0 from "./SearchCourses.vue?vue&type=style&index=0&id=0f265975&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f265975",
  null
  
)

export default component.exports